// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1D5df","additionalInfo":"AgreementModal_additionalInfo__2P0dU"};